import { CSSProperties } from 'react'

interface P {
    size?: number
}

function HelixLoader({ size }: P) {
    const mySize = size ?? 45

    return (
        <div style={{ '--uib-size': `${mySize}px` } as CSSProperties} className='loader-helix-container'>
            <div className='loader-helix-slice'></div>
            <div className='loader-helix-slice'></div>
            <div className='loader-helix-slice'></div>
            <div className='loader-helix-slice'></div>
            <div className='loader-helix-slice'></div>
            <div className='loader-helix-slice'></div>
        </div>
    )
}

export default HelixLoader
